import { Component, OnInit, Input, forwardRef, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const SP_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SpTextareaComponent),
  multi: true
};

@Component({
  selector: 'sp-textarea',
  standalone: false,
  templateUrl: './sp-textarea.component.html',
  styleUrls: ['./sp-textarea.component.scss'],
  providers: [SP_TEXTAREA_VALUE_ACCESSOR]

})
export class SpTextareaComponent implements OnInit, SpTextareaObjectInterface, ControlValueAccessor {
  @ViewChild('textArea', { static: true }) textArea: ElementRef;
  @Input() maxlength: number = 524288;
  @Input() placeholder: string = 'Type Something';
  @Input() icon: string = null;
  @Input() disabled: boolean;
  @Input() rows: number;

  characterCount: number = 0;
  @Input() value: string = '';
  touched: boolean = false;

  propagateChange = (_: any) => {};
  _onTouched = () => {};

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    this.handleErrors();
  }

  writeValue(v: any): void {
    this.value = v;
    if (v) {
      this.value = v;
      this.touched = true;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {
    this._onTouched = fn;
  }

  onBlur() {
    this._onTouched();
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.textArea.nativeElement, 'disabled', isDisabled);
  }

  onKeyUp(textarea) {
    this.value = textarea.target.value;
    if (this.value.length > 0) {
      this.touched = true;
    } else {
      this.touched = false;
    }
    this.propagateChange(this.value);
    this.characterCount = this.value.length;
  }

  private handleErrors() {
    if (this.maxlength) {
      if (typeof this.maxlength !== 'number') {
        console.warn('maxlength should be a number');
      }
    }
  }
}

export interface SpTextareaObjectInterface {
  maxlength?: number;
  placeholder?: string;
  icon?: string;
}